document.addEventListener("DOMContentLoaded", function () {

    var form = document.getElementById("pmFeedbackForm");
    if (!form) return;

    var steps = Array.prototype.slice.call(document.querySelectorAll(".pm-step"));
    var progress = document.getElementById("pmProgress");
    var progressWrap = document.querySelector(".pm-progress");
    var successBox = document.getElementById("pmSuccess");
    var endpoint = (form.dataset.endpoint || "").trim();

    var currentStep = 0;

    /* ===== Step handling ===== */

    function updateStep() {
        steps.forEach(function (step, index) {
            step.classList.toggle("active", index === currentStep);
        });
        if (progress) {
            progress.style.width = ((currentStep + 1) / steps.length) * 100 + "%";
        }
        var wrap = document.querySelector(".pm-wrap");
        if (wrap && wrap.getBoundingClientRect().top < 0) {
            wrap.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }

    function showError(step, message) {
        var err = step.querySelector(".pm-error");
        if (!err) {
            err = document.createElement("div");
            err.className = "pm-error";
            var actions = step.querySelector(".pm-actions");
            step.insertBefore(err, actions || null);
        }
        err.textContent = message;
        err.style.display = "block";
        setTimeout(function () { err.style.display = "none"; }, 4000);
    }

    function validateStep(step) {
        var required = step.dataset.required;
        if (!required) return true;
        var names = required.split(",");
        for (var i = 0; i < names.length; i++) {
            var name = names[i].trim();
            var checked = step.querySelector('input[name="' + name + '"]:checked');
            if (!checked) {
                showError(step, step.dataset.errorMsg || "Please select an option to continue.");
                return false;
            }
        }
        return true;
    }

    form.addEventListener("click", function (e) {
        var next = e.target.closest(".pm-next");
        var prev = e.target.closest(".pm-prev");
        if (next) {
            if (!validateStep(steps[currentStep])) return;
            if (currentStep < steps.length - 1) {
                currentStep++;
                updateStep();
            }
        } else if (prev) {
            if (currentStep > 0) {
                currentStep--;
                updateStep();
            }
        }
    });

    updateStep();

    /* ===== Star rating emoji ===== */

    var emoji = document.getElementById("pmEmoji");
    var emojiMap = { "1": "😞", "2": "😕", "3": "🙂", "4": "😊", "5": "😍" };

    document.querySelectorAll('input[name="rating"]').forEach(function (star) {
        star.addEventListener("change", function () {
            if (emoji) emoji.textContent = emojiMap[this.value] || "🙂";
        });
    });

    /* ===== Missing product (shown for "No" and "Almost") ===== */

    var missingBox = document.getElementById("missingProduct");

    document.querySelectorAll('input[name="found"]').forEach(function (option) {
        option.addEventListener("change", function () {
            if (!missingBox) return;
            missingBox.style.display = (this.value === "No" || this.value === "Almost") ? "block" : "none";
        });
    });

    /* ===== Character counter ===== */

    var suggestion = document.getElementById("pmSuggestion");
    var counter = document.getElementById("pmCharCount");

    if (suggestion && counter) {
        suggestion.addEventListener("input", function () {
            counter.textContent = suggestion.value.length;
        });
    }

    /* ===== Image upload: preview + resize to base64 ===== */

    var upload = document.getElementById("pmImages");
    var preview = document.getElementById("pmPreview");
    var uploadedImages = []; // {name, dataUrl}
    var MAX_IMAGES = 3;
    var MAX_DIMENSION = 1400;

    function renderPreview() {
        if (!preview) return;
        preview.innerHTML = "";
        uploadedImages.forEach(function (img, index) {
            var item = document.createElement("div");
            item.className = "pm-preview-item";
            var el = document.createElement("img");
            el.src = img.dataUrl;
            el.alt = img.name;
            var remove = document.createElement("button");
            remove.type = "button";
            remove.className = "pm-preview-remove";
            remove.textContent = "×";
            remove.addEventListener("click", function () {
                uploadedImages.splice(index, 1);
                renderPreview();
            });
            item.appendChild(el);
            item.appendChild(remove);
            preview.appendChild(item);
        });
    }

    function resizeImage(file) {
        return new Promise(function (resolve) {
            var reader = new FileReader();
            reader.onload = function (e) {
                var img = new Image();
                img.onload = function () {
                    var w = img.width, h = img.height;
                    if (w > MAX_DIMENSION || h > MAX_DIMENSION) {
                        var scale = MAX_DIMENSION / Math.max(w, h);
                        w = Math.round(w * scale);
                        h = Math.round(h * scale);
                    }
                    var canvas = document.createElement("canvas");
                    canvas.width = w;
                    canvas.height = h;
                    canvas.getContext("2d").drawImage(img, 0, 0, w, h);
                    resolve({ name: file.name, dataUrl: canvas.toDataURL("image/jpeg", 0.8) });
                };
                img.onerror = function () { resolve(null); };
                img.src = e.target.result;
            };
            reader.onerror = function () { resolve(null); };
            reader.readAsDataURL(file);
        });
    }

    if (upload && preview) {
        upload.addEventListener("change", function () {
            var files = Array.prototype.slice.call(upload.files)
                .filter(function (f) { return f.type.indexOf("image/") === 0; })
                .slice(0, MAX_IMAGES - uploadedImages.length);

            Promise.all(files.map(resizeImage)).then(function (results) {
                results.forEach(function (r) { if (r) uploadedImages.push(r); });
                renderPreview();
            });
            upload.value = "";
        });
    }

    /* ===== Submit ===== */

    form.addEventListener("submit", function (e) {
        e.preventDefault();

        var lastStep = steps[currentStep];
        if (!validateStep(lastStep)) return;

        // Honeypot: real users never fill this hidden field
        var honeypot = form.querySelector('input[name="pm_website"]');
        if (honeypot && honeypot.value) return;

        var phone = ((form.querySelector('input[name="customer_phone"]') || {}).value || "").trim();
        if (phone) {
            var digits = phone.replace(/[\s\-()]/g, "").replace(/^\+91/, "").replace(/^0/, "");
            if (!/^[6-9]\d{9}$/.test(digits)) {
                showError(lastStep, "Please enter a valid 10-digit mobile number (or leave it empty).");
                return;
            }
            phone = digits;
        }

        function val(name) {
            var checked = form.querySelector('input[name="' + name + '"]:checked');
            if (checked) return checked.value;
            var field = form.querySelector('[name="' + name + '"]');
            return field ? field.value : "";
        }

        var improve = Array.prototype.slice.call(
            form.querySelectorAll('input[name="improve"]:checked')
        ).map(function (c) { return c.value; });

        var payload = {
            rating: val("rating"),
            found: val("found"),
            missing_product: val("missing_product"),
            improve: improve.join(", "),
            suggestion: val("suggestion"),
            shop_again: val("shop_again"),
            customer_name: val("customer_name"),
            customer_phone: phone,
            page_url: window.location.href,
            images: uploadedImages
        };

        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = "Sending...";
        }

        function showSuccess() {
            steps.forEach(function (s) { s.classList.remove("active"); });
            if (progressWrap) progressWrap.style.display = "none";
            if (successBox) {
                successBox.style.display = "block";
                successBox.classList.add("pm-success");
            }
        }

        if (!endpoint) {
            // No endpoint configured yet — still show success so customers
            // aren't stuck, but log for the store owner.
            console.warn("PrintMine Feedback: no Google Apps Script URL set in the section settings — submission was not stored.");
            showSuccess();
            return;
        }

        fetch(endpoint, {
            method: "POST",
            mode: "no-cors",
            headers: { "Content-Type": "text/plain;charset=utf-8" },
            body: JSON.stringify(payload)
        }).then(showSuccess).catch(function () {
            if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.textContent = "Submit Feedback";
            }
            showError(lastStep, "Something went wrong. Please try again.");
        });
    });

});